import React, {useEffect, useState} from 'react';
import {getPageData} from '../../sources/CmsSource';
import {useGetPageData} from '../../actions/CmsActions';
import {SpotlightPage} from 'epic-ue-spotlight';
import {extractSlugLocale} from '@epic-core/localization';
import {getLocale} from '@epic-core/common';
import {useStore} from '../../stores';
import styled from 'styled-components';
import {useSharedValue} from '@epic-core/hooks';
import {AppSharedKeys} from 'epic-ue-shared';
import {useLocation} from 'react-router';
import Error404 from '../error/Error404';
import {useLoading, useNotFound} from '../../utils/loadingUtils';

const SpotlightWrap = styled.div`
    .article-tags {
        display: none;
    }

    .copy ol li {
        text-align: left;
    }

    .ue-anim-content {
        .container {
            margin: 0 20px;
        }
    }
`;

let loadingPage = false;

const NewsDetailView = () => {
    const location = useLocation();
    const pathname = location.pathname || '';
    const {pageSlug} = extractSlugLocale(pathname, getLocale());
    const [store] = useStore();
    const currentPageData = useGetPageData({cmsUrlPattern: pageSlug});
    const [pageData, setPageData] = useState(currentPageData);
    const isLoading = useLoading(pageData);
    const notFound = useNotFound(pageData);
    const [latestFeedItemsStore, setLatestFeedItemsStore] = useSharedValue(AppSharedKeys.FeedItemsLatestStore);
    if ((!latestFeedItemsStore || !latestFeedItemsStore.items || !latestFeedItemsStore.items.length) && store.feedItems) {
        setLatestFeedItemsStore(store.feedItems);
    }

    const {pageSlug: pageDataUrlPatternSlug} = extractSlugLocale(pageData && pageData._urlPattern, getLocale());
    const pageMatch = pageData && pageSlug === pageDataUrlPatternSlug;

    useEffect(() => {
        if (pageMatch || loadingPage) return;
        async function fetchData() {
            loadingPage = true;
            const newPageData = await getPageData(pageSlug);
            loadingPage = false;
            setPageData(newPageData);
        }
        fetchData();
    }, [pageMatch, pageSlug, setPageData]);

    if (notFound) {
        return <Error404 />;
    }

    return (
        <SpotlightWrap>
            <SpotlightPage pageData={pageData || {}} cmsLoading={isLoading || !pageMatch} urlPattern={pageSlug} publisherName="Epic Online Services" />
        </SpotlightWrap>
    );
};

NewsDetailView.getInitialProps = async (match, {locale}, requestedUrl) => {
    const {pageSlug} = extractSlugLocale(requestedUrl, getLocale());

    let rawPageData = {};
    try {
        rawPageData = await getPageData(pageSlug);
    } catch (e) {
        console.error('NewsDetailView failed to load pageData', pageSlug);
        console.error(e.message);
    }

    //must match structure of StoreProvider
    return {
        cms: {
            [pageSlug]: rawPageData
        }
    };
};

export default NewsDetailView;
